import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'published'})
export class Published implements PipeTransform {
  transform(state: number): string {
    if(state==0){
        return 'no';
    }
    return 'yes';
  }
}